{
  "select": "select",
  "save": "Save!",
  "SelectYour": "Select your",
  "Photo": "Photo",
  "photoLimit": "Great photo but it exceeded the max size: 10mb.",
  "skip": "skip for now",
  "selectAvatar": "select avatar",
  "UploadProfile": "Upload Profile"
}
